/**
 * O `<input type="date">` fala em data local (`yyyy-mm-dd`) e a API guarda
 * instantes ISO. A conversão mora aqui, no navegador, que é quem conhece o fuso
 * do usuário - o servidor roda em UTC e erraria o dia nas bordas, fazendo um
 * feriado sumir do mural justamente no dia dele.
 */
export const inicioDoDiaISO = (dataLocal: string): string | null => {
	if (!dataLocal) return null;
	const [ ano, mes, dia ] = dataLocal.split('-').map(Number);
	return new Date(ano, mes - 1, dia, 0, 0, 0, 0).toISOString();
};

/** Fim do dia, para que a janela inclua o último dia por inteiro. */
export const fimDoDiaISO = (dataLocal: string): string | null => {
	if (!dataLocal) return null;
	const [ ano, mes, dia ] = dataLocal.split('-').map(Number);
	return new Date(ano, mes - 1, dia, 23, 59, 59, 999).toISOString();
};

/** Caminho inverso, para preencher o input a partir do que veio da API. */
export const paraDataLocal = (iso: string | null): string => {
	if (!iso) return '';
	const data = new Date(iso);
	if (Number.isNaN(data.getTime())) return '';
	const mes = `${data.getMonth() + 1}`.padStart(2, '0');
	const dia = `${data.getDate()}`.padStart(2, '0');
	return `${data.getFullYear()}-${mes}-${dia}`;
};

/** Formato curto para leitura, ex.: 25/12/2026. */
export const formatarData = (iso: string | null): string => {
	if (!iso) return '';
	const data = new Date(iso);
	if (Number.isNaN(data.getTime())) return '';
	return data.toLocaleDateString('pt-BR');
};
